import { getApiBaseUrl, apiRequest } from './apiClient';

export const BAYILIK_BASVURU_SAYAC_YENILE_EVENT = 'hlm-bayilik-basvuru-sayac-yenile';

const publicBase = () => `${getApiBaseUrl()}/api/public/bayilik-basvuru`;

export const fetchBayilikBasvuruForm = async (token) => {
  const res = await fetch(`${publicBase()}/${encodeURIComponent(token)}`);
  const json = await res.json();
  if (!res.ok) {
    const err = new Error(json.mesaj || 'Form yüklenemedi');
    err.status = res.status;
    throw err;
  }
  return json;
};

export const fetchBayilikBasvuruIlceler = async (token, cityId) => {
  const res = await fetch(
    `${publicBase()}/${encodeURIComponent(token)}/ilceler/${encodeURIComponent(cityId)}`,
  );
  const json = await res.json();
  if (!res.ok) throw new Error(json.mesaj || 'İlçeler yüklenemedi');
  return json;
};

export const checkBayilikKullaniciAdi = async (token, kullaniciAdi) => {
  const res = await fetch(
    `${publicBase()}/${encodeURIComponent(token)}/kullanici-adi?k=${encodeURIComponent(kullaniciAdi)}`,
  );
  const json = await res.json();
  if (!res.ok) throw new Error(json.mesaj || 'Kontrol yapılamadı');
  return json;
};

export const sendBayilikBasvuruOtp = async (token, telefon) => {
  const res = await fetch(`${publicBase()}/${encodeURIComponent(token)}/otp/gonder`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ telefon }),
  });
  const json = await res.json();
  if (!res.ok) {
    const err = new Error(json.mesaj || 'SMS gönderilemedi');
    err.status = res.status;
    throw err;
  }
  return json;
};

export const verifyBayilikBasvuruOtp = async (token, telefon, kod) => {
  const res = await fetch(`${publicBase()}/${encodeURIComponent(token)}/otp/dogrula`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ telefon, kod }),
  });
  const json = await res.json();
  if (!res.ok) {
    const err = new Error(json.mesaj || 'Doğrulama başarısız');
    err.status = res.status;
    throw err;
  }
  return json;
};

export const submitBayilikBasvuru = async (token, payload) => {
  const res = await fetch(`${publicBase()}/${encodeURIComponent(token)}/gonder`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.mesaj || 'Başvuru gönderilemedi');
  return json;
};

export const createBayilikDavet = async () => {
  return apiRequest('/api/bayilik-basvurulari/davet', { method: 'POST' });
};

export const pasifAlBayilikDavet = async (id) => {
  return apiRequest(`/api/bayilik-basvurulari/davet/${encodeURIComponent(id)}/pasif`, {
    method: 'POST',
  });
};

export const fetchBayilikBasvurulari = async ({ sekme = 'onay_bekliyor', sayfa = 1, limit = 20 } = {}) => {
  const params = new URLSearchParams({
    sekme,
    sayfa: String(sayfa),
    limit: String(limit),
  });
  return apiRequest(`/api/bayilik-basvurulari?${params.toString()}`, { method: 'GET' });
};

export const fetchBayilikBasvuruDetay = async (id) => {
  return apiRequest(`/api/bayilik-basvurulari/${encodeURIComponent(id)}`, { method: 'GET' });
};

export const fetchBayilikBasvuruSekmeSayilari = async () => {
  return apiRequest('/api/bayilik-basvurulari/sekme-sayilari', { method: 'GET' });
};

export const onaylaBayilikBasvuru = async (id) => {
  const res = await apiRequest(`/api/bayilik-basvurulari/${encodeURIComponent(id)}/onayla`, {
    method: 'POST',
  });
  window.dispatchEvent(new CustomEvent(BAYILIK_BASVURU_SAYAC_YENILE_EVENT));
  return res;
};

export const reddetBayilikBasvuru = async (id, redNedeni) => {
  const res = await apiRequest(`/api/bayilik-basvurulari/${encodeURIComponent(id)}/reddet`, {
    method: 'POST',
    body: JSON.stringify({ redNedeni }),
  });
  window.dispatchEvent(new CustomEvent(BAYILIK_BASVURU_SAYAC_YENILE_EVENT));
  return res;
};

export const refreshBayilikBasvuruSayac = () => {
  window.dispatchEvent(new CustomEvent(BAYILIK_BASVURU_SAYAC_YENILE_EVENT));
};
